// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'

/*分页 */
import Pagination from '@/components/Pagination'

/* axios */
import axios from './api'
Vue.prototype.http = axios;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/common.css'
import './assets/css/element.css'
import "./assets/css/link.scss"

/* animate.css */
import 'animate.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import store from './store'


//导入图片预览viewer组件以及css
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)


import VueBus from 'vue-bus';
Vue.use(VueBus);

/*base64加密*/
import * as Base64 from 'js-base64'
Vue.use(Base64)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)
Vue.component('Pagination', Pagination)
Vue.config.productionTip = false

//引入 i18n 
import i18n from './lang'

//element官方方法 
//为了实现element插件的多语言切换
Vue.use(ElementUI,{
  i18n:(key,value) =>i18n.t(key,value)
})


/* import translate from 'i18n-jsautotranslate'
translate.setUseVersion2() //设置使用v2.x 版本
translate.selectLanguageTag.show = false //是否显示切换栏
translate.listener.start()
Vue.prototype.$translate = translate */


Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});


new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js